import React from "react";

import {
    Input,
    Col,Row
} from "reactstrap";
import InputRadio from '../FormParts/InputRadio'
import InputText from '../FormParts/InputText'
import {
    cst_invoice_payment_type,
    cst_invoice_business_type
} from '../../variables/codes_map';
import Convert from '../../common/Convert';


export default class InputInvoice extends React.Component {
    constructor(props) {
        super(props);

        // console.log(props.names)
        if(this.props.names["payment_type"]) {
            this.withoutPaymentType = false
            this.paymentTypeName = Convert.key_split(this.props.names["payment_type"]).column
        } else {
            // payment_type未指定なら仕入先、その他の選択なしで　未確認の選択が追加される
            this.withoutPaymentType = true
            this.paymentTypeName = null
        }

        this.state = {
            visible: this.props.visible !== undefined ? this.props.visible : true,
            rows: this.props.rows !== undefined? this.props.rows: true,
        };
    }

    componentDidUpdate(prevProps) {
        // if (JSON.stringify(this.props) === JSON.stringify(prevProps))
        //     return;

        // this.setState({
        //     id_title: this.props.id_title ? this.props.id_title : '',
        //     id_value: this.props.id_value ? this.props.id_value : '',
        //     update_timestamp: this.props.update_timestamp ? this.props.update_timestamp : '',
        //     update_user: this.props.update_user ? this.props.update_user : '',
        //     update_user_picture: this.props.update_user_picture ? this.props.update_user_picture : '',
        //     visible: this.props.visible !== undefined ? this.props.visible : true
        // });
    }

    render_body () {
        return (<>
                {this.props.labelOn && <div style={{marginTop:"auto",marginBottom:"auto"}}>{this.props.label}</div>}
                {!this.withoutPaymentType && <>
                <MyInputRadio
                    name={this.props.names["payment_type"]}
                    rootData={this.props.rootData}
                    disabled={this.props.disabled}
                    options={cst_invoice_payment_type}
                    validateCallback={this.props.validateCallback} 
                    validateType='regist'
                />（</>}
                <InvoiceInputRadio
                    name={this.props.names["business_type"]}
                    nameOfinputText={this.props.names["registration_number"]}
                    rootData={this.props.rootData}
                    disabled={this.props.disabled || (!this.withoutPaymentType && this.props.rootData.values[this.paymentTypeName] != '1')}
                    options={cst_invoice_business_type}
                    validateCallback={this.props.validateCallback} 
                    validateType='regist'
                    withUnconfirmed={this.props.names["with_unconfirmed"]}
                    rows={this.state.rows}
                    viewUntax={this.props.viewUntax == undefined ? false : this.props.viewUntax}
                />
                {!this.withoutPaymentType && <>）</>}
        </>);
    }

    render() {
        let elements = this.render_body();
        return (
            <>
                {this.state.visible && (() => {
                    return (<>
                        {this.state.rows ? (<Row style={{lineHeight:"2.5em"}}>{elements}</Row>):(<>{elements}</>)}
                    </>)
                })()}
            </>
        );
    }
}

class MyInputRadio extends InputRadio {

    constructor(props) {
        super(props);
    }

    render() {
        const{
            disabled,
            disabled_options,
            name,
            rootData:{
                errors,
                values
            },
            options,
            labelOn,
            label,
            description,
            customMessage
        } = this.props
        
        const columnObject = Convert.key_split(name)
        var value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]
        var default_value = options[0]["default"];
        if(!default_value){
            default_value = 0;
        }
        // if(value === undefined || value === null){
        //     value = default_value;
        // }

        return (
            <>
                {labelOn && <div>{label} : </div>}
                {options.map((data, index) => (
                    <label key={`${name}-${index}`} style={{margin:"auto"}}>
                        <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(data.value)} type="radio" name={name} id={`${name}-${data.value}`} value={data.value} checked={String(value) === String(data.value)} onChange={this.handle_change}
                            onKeyDown={(e) => this.handle_keyDown(e)} />{data.label}&nbsp;
                    </label>
                ))}{description}
                {/* {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                } */}
                {customMessage && <span>{customMessage}</span>}
            </>
        );
    }
}

class InvoiceInputRadio extends InputRadio {

    constructor(props) {
        super(props);
        this.state = {
            rows: this.props.rows
        }
        this.businessTypeName = Convert.key_split(this.props.name).column
    }

    render() {
        const{
            disabled,
            disabled_options,
            name,
            rootData:{
                errors,
                values
            },
            options,
            labelOn,
            label,
            description,
            customMessage,
        } = this.props
        
        const columnObject = Convert.key_split(name)
        var value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]
        var default_value = options[0]["default"];
        if(!default_value){
            default_value = 0;
        }
        if(value === undefined || value === null){
             value = default_value;
        }

        let defaultStyle = (this.state.rows)?{}:{width:"200px",display:"inline-block"}
        
        return (
            <>
                {labelOn && <div>{label} : </div>}
                <label key={`${name}-1`} style={{margin:"auto"}}>
                    <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(cst_invoice_business_type[1].value)} type="radio" name={name} id={`${name}-${cst_invoice_business_type[1].value}`} value={cst_invoice_business_type[1].value} checked={String(value) === String(cst_invoice_business_type[1].value)} onChange={this.handle_change}
                        onKeyDown={(e) => this.handle_keyDown(e)} />{cst_invoice_business_type[1].label}&nbsp;
                </label>
                <InputText
                    label="適格事業者番号"
                    name={this.props.nameOfinputText}
                    rootData={this.props.rootData}
                    validateCallback={this.props.validateCallback}
                    maxlength={14}
                    validateType='regist'
                    disabled={disabled || values[this.businessTypeName] != "1"}
                    parentStyle={defaultStyle}
                />&nbsp;
                {/* 非課税は表示しない */}
                {this.props.viewUntax && (
                <label key={`${name}-3`} style={{margin:"auto"}}>
                    <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(cst_invoice_business_type[3].value)} type="radio" name={name} id={`${name}-${cst_invoice_business_type[3].value}`} value={cst_invoice_business_type[3].value} checked={String(value) === String(cst_invoice_business_type[3].value)} onChange={this.handle_change}
                        onKeyDown={(e) => this.handle_keyDown(e)} />{cst_invoice_business_type[3].label}&nbsp;
                </label>)}
                <label key={`${name}-2`} style={{margin:"auto"}}>
                    <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(cst_invoice_business_type[2].value)} type="radio" name={name} id={`${name}-${cst_invoice_business_type[2].value}`} value={cst_invoice_business_type[2].value} checked={String(value) === String(cst_invoice_business_type[2].value)} onChange={this.handle_change}
                        onKeyDown={(e) => this.handle_keyDown(e)} />{cst_invoice_business_type[2].label}&nbsp;
                </label>
                {this.props.withUnconfirmed && <>
                <label key={`${name}-0`} style={{margin:"auto"}}>
                    <Input className={`tabable`} disabled={disabled?disabled:disabled_options.includes(cst_invoice_business_type[0].value)} type="radio" name={name} id={`${name}-${cst_invoice_business_type[0].value}`} value={cst_invoice_business_type[0].value} checked={String(value) === String(cst_invoice_business_type[0].value)} onChange={this.handle_change}
                        onKeyDown={(e) => this.handle_keyDown(e)} />{cst_invoice_business_type[0].label}&nbsp;
                </label></>}
                {description}
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
                {customMessage && <span>{customMessage}</span>}
            </>
        );
    }
}
